import { render, staticRenderFns } from "./footer-images.vue?vue&type=template&id=22c9633d&scoped=true&"
import script from "./footer-images.vue?vue&type=script&lang=js&"
export * from "./footer-images.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22c9633d",
  null
  
)

export default component.exports